module.exports = __webpack_public_path__ + "img/halt.a13aa8cd.svg";